import { ArtOilRoute } from './route.models';

// Auth
export class AuthRoutes {
  public static root: ArtOilRoute = {
    path: '',
    url: '/'
  };

  public static Login: ArtOilRoute = {
    path: 'login',
    url: '/'
  };

  public static ForgotPassword: ArtOilRoute = {
    path: 'forgot-password',
    url: '/forgot-password'
  };

  public static ResetPassword: ArtOilRoute = {
    path: 'reset-password',
    url: '/forgot-password'
  };
}

// Root
export class RootRoutes {
  public static Error404: ArtOilRoute = {
    path: 'error404',
    url: '/error404'
  };
}

// App
export class AppRoutes {
  public static root: ArtOilRoute = {
    path: 'app',
    url: '/app',
    name: 'app'
  };

  public static MyCompany: ArtOilRoute = {
    path: 'my-company',
    url: '/app/my-company',
    name: 'myCompany'
  };

  public static FinancialReports: ArtOilRoute = {
    path: 'financial-reports',
    url: '/app/financial-reports',
    name: 'financialReports'
  };

  public static Cards: ArtOilRoute = {
    path: 'cards',
    url: '/app/cards',
    name: 'cards'
  };

  public static Demo: ArtOilRoute = {
    path: 'demo',
    url: '/app/demo',
    name: 'demo'
  };
}

// My Company
export class MyCompanyRoutes {
  public static root: ArtOilRoute = {
    path: 'my-company',
    url: '/app/my-company',
    name: 'myCompany'
  };

  public static Dashboard: ArtOilRoute = {
    path: 'dashboard',
    url: '/app/my-company/dashboard',
    name: 'dashboard'
  };

  public static Users: ArtOilRoute = {
    path: 'users',
    url: '/app/my-company/users',
    name: 'users'
  };
}

// Financial Reports
export class FinancialReportsRoutes {
  public static root: ArtOilRoute = {
    path: 'financial-reports',
    url: '/app/financial-reports',
    name: 'financialReports'
  };

  public static Invoices: ArtOilRoute = {
    path: 'invoices',
    url: '/app/financial-reports/invoices',
    name: 'invoices'
  };

  public static CancelledInvoices: ArtOilRoute = {
    path: 'cancelled-invoices',
    url: '/app/financial-reports/cancelled-invoices',
    name: 'cancelledInvoices'
  };

  public static Clients: ArtOilRoute = {
    path: 'clients',
    url: '/app/financial-reports/clients',
    name: 'clients'
  };

  public static Volumes: ArtOilRoute = {
    path: 'volumes',
    url: '/app/financial-reports/volumes',
    name: 'volumes'
  };

  public static VolumesFiles: ArtOilRoute = {
    path: 'volumes-files',
    url: '/app/financial-reports/volumes-files',
    name: 'volumesFiles'
  };
}

// Cards
export class CardsRoutes {
  public static root: ArtOilRoute = {
    path: 'cards',
    url: '/app/cards',
    name: 'cards'
  };

  public static Transactions: ArtOilRoute = {
    path: 'transactions',
    url: '/app/cards/transactions',
    name: 'transactions'
  };

  public static Requests: ArtOilRoute = {
    path: 'requests',
    url: '/app/cards/requests',
    name: 'requests'
  };

  public static Settings: ArtOilRoute = {
    path: 'settings',
    url: '/app/cards/settings',
    name: 'settings'
  };

  public static SettingsHistory: ArtOilRoute = {
    path: 'settings-history',
    url: '/app/cards/settings-history',
    name: 'settingsHistory'
  };
}
